import _ from 'lodash';
import { updateJobStateSucceed } from '../actions';
import { getJob, JOB_NAMES } from 'common/services/jobs-suites.service';

export function getJobDetails(jobName) {
  return async dispatch => {
    try {
      const jobStats = await getJob(jobName);
      const jobDetails = _.get(
        jobStats,
        `jobs${jobName === JOB_NAMES.REPOSITORY_BACKFILL ? '' : '[0]'}`,
        {}
      );
      dispatch(updateJobStateSucceed({ jobName, jobDetails }));
      return jobDetails;
    } catch (e) {
      throw e;
      // Handle failure when an indication is needed
    }
  };
}

export function getJobsDetails(jobName) {
  return async dispatch => {
    try {
      const jobStats = await getJob(jobName);
      const jobDetails = _.get(jobStats, 'jobs', []);
      dispatch(updateJobStateSucceed({ jobName, jobDetails }));
      return jobDetails;
    } catch (e) {
      throw e;
      // Handle failure when an indication is needed
    }
  };
}
